import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ServiceDetailsComponent } from './services-list/service-details/service-details.component';
import { ServicesListComponent } from './services-list/services-list.component';
import { ServiceCategoryComponent } from './service-category/service-category.component';
import { AuthGuard } from '../_guards/auth.guard';
import { PermissionGuard } from '../_guards/permission.guard';
import { ServiceCategoryCreateComponent } from './service-category/service-category-create/service-category-create.component';
import { ServiceDetailResolver } from './services-list/service-details/service.resolver';
import { ServiceOverviewComponent } from './services-list/service-details/service-overview/service-overview.component';
import { ServicePricingComponent } from './services-list/service-details/service-pricing/service-pricing.component';
import { ServiceScopingComponent } from './services-list/service-details/service-scoping/service-scoping.component';
import { ServiceTransportationComponent } from './services-list/service-details/service-transportation/service-transportation.component';
import { ServiceUnitsOfChargeComponent } from './service-units-of-charge/service-units-of-charge.component';
import { AddRegionComponent } from './services-list/service-details/service-scoping/add-region/add-region.component';
import { ServiceFormService } from './services-list/service-details/service-form.service';
import { ServiceOrderShellComponent } from './service-orders/service-order-shell/service-order-shell.component';
import { ServiceOrderTableComponent } from './service-orders/service-order-table/service-order-table.component';


const categoriesRoutes: Routes = [
  {
    path: 'categories',
    component: ServiceCategoryComponent,
    canActivate: [AuthGuard, PermissionGuard],
    data: {
      title: 'Categories',
      permissions: ['services-category:view']
    },
    children: [
      {
        path: 'new',
        component: ServiceCategoryCreateComponent
      },
      {
        path: ':id',
        component: ServiceCategoryCreateComponent
      }
    ]
  },
]

const ordersRoutes = [
  {
    path: 'orders',
    redirectTo: 'orders/all',
    pathMatch: 'full',
  },
  {
    path: 'farm-plan',
    redirectTo: 'farm-plan/all',
    pathMatch: 'full',
  },
  {
    path: 'garden-mapping',
    redirectTo: 'garden-mapping/all',
    pathMatch: 'full',
  },
  {
    path: 'soil-testing',
    redirectTo: 'soil-testing/all',
    pathMatch: 'full',
  },
  {
    path: ':service-name',
    component: ServiceOrderShellComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'all',
        component: ServiceOrderTableComponent,
      },
    ],
  },
]
const routes: Routes = [
  {
    path: '',
    component: ServicesListComponent,
    children: categoriesRoutes,
    data: {
      title: 'Services List',
    }
  },
  {
    path: 'orders',
    children: ordersRoutes,
  },
  {
    path: 'service-providers',
    loadChildren: () => import('./service-providers/service-providers.module').then(m => m.ServiceProvidersModule)
  },
  {
    path: ':id',
    redirectTo: ':id/overview',
    pathMatch: "full",
  },
  {
    path: ':id',
    component: ServiceDetailsComponent,
    children: [
      ...categoriesRoutes,
      {
        path: 'overview',
        component: ServiceOverviewComponent,
        children: [
          {
            path: 'unit-of-charge',
            component: ServiceUnitsOfChargeComponent
          },
          ...categoriesRoutes
        ]
      },
      {
        path: 'pricing',
        component: ServicePricingComponent,
        children: categoriesRoutes
      },
      {
        path: 'scope',
        component: ServiceScopingComponent,
        canActivate: [AuthGuard, PermissionGuard],
        data: {
          title: 'Scope',
          permissions: ['services:view_service_scoping']
        },
        children: [
          ...categoriesRoutes,
          {
            path: ':regionId',
            component: AddRegionComponent
          }
        ]
      },
      {
        path: 'transport',
        component: ServiceTransportationComponent,
        children: categoriesRoutes,
        canActivate: [AuthGuard, PermissionGuard],
        data: {
          permissions: ['services:edit_service_transport']
        }
      }
    ],
    resolve: {
      serviceDetails: ServiceDetailResolver
    }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [ServiceDetailResolver, ServiceFormService]
})
export class ServicesRoutingModule { }
